export const UploaderAcceptance: any = {
    images: {
        'image/*': []
    },
    video: {
        'video/*': []
    }
};